<script lang="ts" setup>
import { Vue3Lottie } from 'vue3-lottie'
import MilestoneAnimation from "@/assets/features_milestones.json";
const milestones = ref();
const box = ref<HTMLElement|null>(null)
const controller = ref();

if (import.meta.client) {
  onMounted(() => {
    const io = new IntersectionObserver(([e]) => {
      if ((e as any).isIntersecting) {
        controller.value?.stop?.()
        controller.value?.play?.()
      } else {
        controller.value?.pause?.()
      }
    }, { threshold: 0.1 })

    if (box.value) io.observe(box.value)
    onBeforeUnmount(() => io.disconnect())
  })
}
</script>
<template>
    <div ref="box">

        <div class="px-4 lg:mx-auto max-w-screen-lg">
            <div ref="milestones" class="flex flex-col md:flex-row-reverse gap-8 bg-[#F2E8FE] mx-auto rounded-2xl items-center py-8 md:py-12 px-8 md:px-10">
							<div class="w-full md:mt-4 bg-primary-500 px-6 pt-4 md:py-10 rounded-xl">

								<client-only> 
									<Vue3Lottie
											ref="controller"
											alt="Smoxy milestones aniamtion"
									
											:loop="false"
											:auto-play="false"
											:animationData="MilestoneAnimation" 
											/>
							 </client-only> 
							</div>
                
                <div class="pt-6 md:pt-0 md:px-0">
                    <p class="text-[#7E1EF8]">{{$t('home.features.milestones.title')}}</p>
                    <h3 class="text-3xl pr-4 font-bold font-owners text-dark-900">{{$t('home.features.milestones.headline')}}</h3>
                    <p class="pt-4">{{$t('home.features.milestones.body')}}</p>
                </div> 
                
                
            </div>
        </div>

    </div>
</template>